export default "__VITE_ASSET__DLZe6za___"